import { Button } from '@rocketmakers/armstrong';
import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { IUploaded } from '../../../../shared/api-clients/_api';
import { ImageUpload } from '../../../../shared/components/imageUpload';
import { useBee } from '../../../../shared/hooks/useBee';
import { BackButton } from '../../components/buttons/back-button';
import { useRoutePaths } from '../../../../shared/context/paths';
import { routePaths } from '../../routes';
import { Spinner } from '../../components/spinner/spinner';

export const StickerImageView: React.FunctionComponent<RouteComponentProps> = () => {
  const { beeInfo, updateBee, loading } = useBee();
  const { push } = useRoutePaths();
  const [image, setImage] = React.useState<IUploaded>(beeInfo?.bee?.stickerImage);
  const [canContinue, setContinue] = React.useState(image && !loading);
  React.useEffect(() => {
    setContinue((beeInfo?.bee?.stickerImage || image) && !loading);
  }, [beeInfo, image]);

  const handleContinue = async () => {
    await updateBee({ deviceId: beeInfo?.bee?.deviceId, stickerImage: image });
    push(routePaths.address.root);
  };

  return (
    <div>
      {loading && <Spinner />}
      <BackButton />
      <h1>
        Device <span className="color-primary">Sticker</span>
      </h1>

      <div>
        <p>Take a photograph of the device ID sticker and upload</p>
        <ImageUpload
          existingImage={beeInfo?.bee?.stickerImage}
          imageName={`${beeInfo?.bee?.deviceId}_sticker-photo`}
          onUpload={setImage}
        />
      </div>

      <div className="row">
        <Button
          data-qa="continue-button"
          id="save-future-update"
          className="continue-button btn-full btn-large"
          disabled={!canContinue}
          onClick={handleContinue}
        >
          Continue
        </Button>
      </div>
    </div>
  );
};
